// Sibling imports
const { CLOSE, OPEN } = require('./actions')
const StumbleUponSubmitModalRecord = require('./record')

function stumbleUponSubmitModalReducer(state = null, { type, payload }) {
  switch (type) {
    case CLOSE:
      return null
    case OPEN:
      return new StumbleUponSubmitModalRecord({
        addHref: payload.url
      })
    default:
      return state
  }
}

module.exports = stumbleUponSubmitModalReducer
